import { type ComponentPropsWithoutRef, type ReactElement } from 'react';

import { Spinner } from './Spinner.js';
import styles from './Button.module.css';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
type ButtonSize = 'md' | 'lg';

export interface ButtonProps extends ComponentPropsWithoutRef<'button'> {
    variant?: ButtonVariant | undefined;
    size?: ButtonSize | undefined;
    /** Shows a spinner, sets aria-busy and prevents further clicks. */
    loading?: boolean | undefined;
}

export function Button({
    variant = 'primary',
    size = 'md',
    loading = false,
    disabled,
    className,
    children,
    type = 'button',
    ...rest
}: ButtonProps): ReactElement {
    const classes = [styles.button, styles[variant], styles[size], className]
        .filter(Boolean)
        .join(' ');
    return (
        <button
            type={type}
            className={classes}
            disabled={disabled === true || loading}
            aria-busy={loading || undefined}
            {...rest}
        >
            {loading ? <Spinner size="sm" label="Working" /> : null}
            <span className={styles.label}>{children}</span>
        </button>
    );
}
